import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  ViewEncapsulation,
} from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CdkAccordionItem } from '@angular/cdk/accordion';
import {
  faChevronDown,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'lyceo-accordion-item',
  imports: [FaIconComponent],
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    'class': 'lyceo-accordion-item',
    '[class.is-expanded]': 'expanded',
  },
})
export class AccordionItemComponent extends CdkAccordionItem {
  public readonly showChevron: InputSignal<boolean | null> = input<
    boolean | null
  >(true);

  protected readonly faChevronDown: IconDefinition = faChevronDown;
}
